<template>
	<div>
		<card title="Dashboard" icon="fas fa-chart-bar">
			<chart-options :links="links" @index="index" @reset="reset"></chart-options>

			<div class="row">
				<div class="col-md-6">
					<table id="table-request-sample-types" style="display: none;">
						<tr>
							<th>Nombre</th>
							<th>Cantidad</th>
						</tr>
						<tbody>
							<tr v-for="item in dashboardData.requestSampleTypes" :key="item.id" >
								<td>{{ item.name }}</td>
								<td>{{ item.quantity }}</td>
							</tr>
						</tbody>
					</table>

					<div id="chart-container-1"></div>
				</div>
				<div class="col-md-6">
					<table id="table-sample-targets" style="display: none;">
						<tr>
							<th>Nombre</th>
							<th>Cantidad</th>
						</tr>
						<tbody>
							<tr v-for="item in dashboardData.sampleTargets" :key="item.id" >
								<td>{{ item.name }}</td>
								<td>{{ item.quantity }}</td>
							</tr>
						</tbody>
					</table>
					<div id="chart-container-3"></div>
				</div>
			</div>
			<div class="row mt-4"> 
				<div class="col-md-12 mt-2">
					<table id="table-cost-centers" style="display: none;">
						<tr>
							<th>Nombre</th>
							<th>Cantidad</th>
						</tr>
						<tbody>
							<tr v-for="item in dashboardData.costCenters" :key="item.id" >
								<td>{{ item.name }}</td>
								<td>{{ item.quantity }}</td>
							</tr>
						</tbody>
					</table>
					<div id="chart-container-2"></div>
				</div>
			</div>
		</card>

	</div>
</template>

<script>
import { Get } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
//import $ from "jquery";
import { getUrlQuery } from "../../helper/queryHelper";
import Highcharts from "highcharts";

export default {
	components: {
		Card
	},
	data() {
		return {
			apiUrl: this.$store.getters.apiUrl,
			Get,
			links: {},
			getUrlQuery,
			dashboardData: {}
		};
	},
	watch: {
		urlQuery: function () {
			this.index()
		}
	},
	created() {
		this.index();
	},
	methods: {
		index() {
			this.$store.commit("setLoading", true);
			this.Get(this.apiUrl + "v1/Dashboard?" + this.urlQuery, res => {
				this.dashboardData = res.data;
				this.$nextTick(() => {
					this.createCharts();
				});
				this.$store.commit("setLoading", false);
			});
		},
		createCharts() {
			// Generar gráficos directamente desde los datos obtenidos en dashboardData
			// Se oculta la serie de Guarda Botella/Semielaborado cuando no tiene registros (cantidad 0).
			const sampleTypes = (this.dashboardData.requestSampleTypes || []).filter(item => {
				const name = (item.name || '').toLowerCase();
				const isSemi = name.includes('guarda botella') || name.includes('semielaborado');
				return !isSemi || parseInt(item.quantity, 10) > 0;
			});
			this.createChart('chart-container-1', 'Tipo de Muestra', sampleTypes, 'bar');
			this.createChart('chart-container-2', 'Centros de Costo', this.dashboardData.costCenters, 'column');
			this.createChart('chart-container-3', 'Objetivos de Muestra', this.dashboardData.sampleTargets, 'bar');
		},
		createChart(containerId, chartTitle, data, type) {
			const categories = [];
			const seriesData = [];

			// Extraer los datos directamente desde la respuesta de la API
			data.forEach(item => {
				categories.push(item.name);  // Nombre del ítem
				seriesData.push(parseInt(item.quantity, 10));  // Cantidad del ítem, forzado a entero
			});

			// Crear el gráfico
			Highcharts.chart(containerId, {
				chart: {
					type: type
				},
				title: {
					text: chartTitle
				},
				xAxis: {
					categories: categories,
					title: {
						text: null
					}
				},
				yAxis: {
					min: 0,
					title: {
						text: 'Cantidad',
						align: 'high'
					}
				},
				legend: {
					enabled: false  // Oculta la leyenda
				},
				credits: {
					enabled: false
				},
				series: [{
					name: chartTitle,
					data: seriesData,
					colorByPoint: true
				}]
			});
		},
		reset() {
			this.links = {}
			this.index()
		},
	},
	computed: {
		urlQuery() {
			return this.getUrlQuery()
		}
	}

}

</script>